import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";

import { SystemCodeSelect, DateInput } from "../inputs";

function VehicleInspectionForm({ inputs, onChange }) {
  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <SystemCodeSelect
            icon="search"
            label="Inspection Type"
            lookup={{ Category: "Fleet", Code: "VehicleInspectionType" }}
            name="InspectionTypeRecIdRef"
            value={inputs.InspectionTypeRecIdRef}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Inspection Date</Label>
          <DateInput
            name="InspectionDate"
            type="date"
            value={inputs.InspectionDate}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>Odometer Reading</Label>
          <Input
            autocomplete="new"
            name="OdometerReading"
            type="text"
            value={inputs.OdometerReading}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Mileage Interval</Label>
          <Input
            autocomplete="new"
            name="MileageInterval"
            type="text"
            value={inputs.MileageInterval}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Days Interval</Label>
          <Input
            autocomplete="new"
            name="DaysInterval"
            type="text"
            value={inputs.DaysInterval}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control expanded>
          <Label>Inspected By</Label>
          <Input
            autocomplete="new"
            name="InspectedBy"
            type="text"
            value={inputs.InspectedBy}
            onChange={onChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}

VehicleInspectionForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
VehicleInspectionForm.defaultProps = {
  inputs: {}
};
export default VehicleInspectionForm;
